import {
    SET_SEARCH, UPDATE_SEARCH, RESET_SEARCH,CHANGE_SEARCH_CATEGORY
} from '../constants'
import store from '../store'

export const setSearch = data => store.dispatch({ type: SET_SEARCH, data })
export const updateSearch = data => store.dispatch({ type: UPDATE_SEARCH, data })
export const resetSearch = () => store.dispatch({ type: RESET_SEARCH })
export const changeSubCategory = data => store.dispatch({ type: CHANGE_SEARCH_CATEGORY, data })
